






































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'DateField',
})
export default class DateField extends Vue {
  @Prop() readonly title;
  @Prop() readonly date;
  // private date = new Date().toISOString().substr(0, 10);
  private menu = false;
}
